import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const InputText = props => {
  const {
    isField,
    error,
    popoverIcon,
    ...extraProps
  } = props;
  // $FlowFixMe[cannot-spread-inexact]
  return /*#__PURE__*/_jsx("input", {
    type: "text",
    className: "form-control",
    ...extraProps
  });
};
export default InputText;